import { Box, Chip, Typography } from '@mui/material';

import { CONNECTOR_LINE_COLOR } from '../analyticalVariableCard.constants';

type ConnectorEmphasis = 'primary' | 'secondary' | 'temporal';

interface LogicConnectorProps {
  label: string;
  emphasis?: ConnectorEmphasis;
  'data-testid'?: string;
}

const CHIP_SX = {
  borderRadius: 0.5,
  bgcolor: 'grey.200',
  color: 'text.primary',
  fontSize: 12,
  fontWeight: 400,
  height: 20,
  '& .MuiChip-label': { px: 0.5 },
} as const;

export const LogicConnector = ({
  label,
  emphasis = 'primary',
  'data-testid': dataTestId,
}: LogicConnectorProps) => {
  if (emphasis === 'secondary') {
    return (
      <Typography
        data-testid={dataTestId}
        variant="caption"
        color="text.secondary"
        sx={{ my: 0.5, fontWeight: 'medium', letterSpacing: '0.02em' }}
      >
        {label}
      </Typography>
    );
  }

  const showLines = emphasis === 'primary';

  return (
    <Box
      data-testid={dataTestId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: emphasis === 'temporal' ? 1.5 : 0.75,
        mt: emphasis === 'temporal' ? -1 : 0,
        px: showLines ? 2 : 0,
        ...(emphasis === 'temporal' && { justifyContent: 'center' }),
      }}
    >
      {showLines && <Box sx={{ flex: 1, height: '1px', bgcolor: CONNECTOR_LINE_COLOR }} />}
      <Chip label={label} size="small" sx={CHIP_SX} />
      {showLines && <Box sx={{ flex: 1, height: '1px', bgcolor: CONNECTOR_LINE_COLOR }} />}
    </Box>
  );
};
